<osc-base-table [items]="_items" [columns]="columns" [hideMarkedBar]="true" [showCheckboxColumn]="false">
    <ng-container cdkColumnDef="documentNumber">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS_LIST.TABLE.DOCUMENT_NO' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">{{ row.rowData.id }}</td>
    </ng-container>
    <ng-container cdkColumnDef="groupTitle">
        <th cdk-header-cell *cdkHeaderCellDef>
            <osc-text-table-header
                [name]="'SPARE_PARTS_LIST.TABLE.PRODUCT' | translate"
                class="header-availability"
            ></osc-text-table-header>
        </th>
        <td cdk-cell *cdkCellDef="let row">{{ row.rowData.productName }}</td>
    </ng-container>
    <ng-container cdkColumnDef="url">
        <th cdk-header-cell *cdkHeaderCellDef></th>
        <td cdk-cell *cdkCellDef="let row">
            <sew-button hierarchy="secondary" size="xs" icon="arrow-chevron-right">
                <button (click)="onSearch(row.rowData.id)">
                    {{ 'SPARE_PARTS_LIST.TABLE.SHOW' | translate }}
                </button>
            </sew-button>
        </td>
    </ng-container>
    <ng-container cdkColumnDef="expandableRow"> </ng-container>
    <ng-container cdkColumnDef="fullRowContent"> </ng-container>
    <ng-container cdkColumnDef="groupHeaderIcon"> </ng-container>
    <ng-container cdkColumnDef="groupHeaderName"> </ng-container>
</osc-base-table>
